import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { DetailRow } from "./baseDetails";

export default function modelDataValueUpdateLstAddDetails({ row }) {
    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <DetailRow label="Added at Index">
                <span className="font-mono bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded">{row.index}</span>
            </DetailRow>
        </ModelDataValueUpdateDetailsBase>
    );
}
